// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__mAtfs","footerText":"Footer_footerText__BbmC4","footerImg":"Footer_footerImg__38w3E","footerBottom":"Footer_footerBottom__l-f-b"};